import { RESTAURANT_BUSINESS_TYPE } from '../constants/constants';

export function businessIsRestaurant(business) {
  return business.category.toLowerCase() === RESTAURANT_BUSINESS_TYPE;
}
